<template>
    <v-container class="pa-0" fluid>
        <v-container v-if="loading">
            <cardWait />
        </v-container>
        <v-card class="pa-2" v-if="!loading">
            <v-card-title class="pt-0 pb-2 justify-center"><h2>Accommodation Faq's</h2> <btn_component ref="info" :tooltip="faqTooltip" type="avatar_text" size="small" text="i" data="" @actionClick="showInfo"/></v-card-title>
            <v-divider></v-divider>
            <v-card-text>
                This page gives a complete overview of all accommodation FAQ's.
                Accommodation FAQ's can be created, edited and removed at the accommodation.<br>
                The accommodation FAQ's need to be uploaded to the "openai platform" (ChatGPT) before the assistants can use them.
                Use the <b>UPLOAD</b> button to upload the latest version.
            </v-card-text>            
            <v-divider></v-divider>
            <v-row class="pa-4">
                <v-spacer></v-spacer>
                <span class="pl-4">
                    <btn_component ref="upload" tooltip="Upload to OpenAI" type="text" size="small" text="Upload" data="" @actionClick="uploadFiles"/>
                </span>
                <span class="pl-4">
                    <v-btn class="primary" small @click="buildReport" :disabled="disableExport" color="success">
                        <v-icon small class="pr-2">mdi-microsoft-excel</v-icon>
                        <span>Export</span>
                    </v-btn>
                </span>                
                <!-- <v-btn class="primary" small @click="buildReport" :disabled="disableExport" color="success">
                    <v-icon small class="pr-2">mdi-microsoft-excel</v-icon>
                    <span class="pr-1">Export</span>
                </v-btn> -->
            </v-row>
            <v-divider></v-divider>
            <v-row>
                <v-col cols="6"><v-text-field v-model="search" label="Search accommodation faq's" single-line hide-details prepend-icon="mdi-magnify"></v-text-field></v-col>
                <v-col cols="3"><selector ref="language" :options="languageCodes" option_field="languageCodesSelected" label="Filter on language" :visibleChips=4 @updateData="updateData"/></v-col>
                <v-col cols="3"><selector ref="accommodation" :options="accommodationCodes" option_field="accommodationCodesSelected" label="Filter on accommodation" :visibleChips=4 @updateData="updateData"/></v-col>
            </v-row>
            <v-divider></v-divider>
            <v-data-table 
                :items="filteredFaqs" 
                :items-per-page="10" 
                :footer-props="{'items-per-page-options': [10, 50, 100, 200, -1]}"
                :headers="headers"
                :search="search">
                <template v-slot:item="props">
                    <tr>
                        <!-- <td @click="$router.open('/pten/onPten/' + props.item.pten_encrid)"><a>{{ props.item.pten_code }}</a></td> -->
                        <td>{{ props.item.language }}</td>
                        <td>{{ props.item.accommodation }}</td>
                        <td><longTextView :long_text="props.item.question" :max_width="300"/></td>
                        <td><longTextView :long_text="props.item.answer" :max_width="600"/></td>
                        <td>
                            <!-- <v-tooltip bottom>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn 
                                        x-small 
                                        text icon 
                                        v-bind="attrs" 
                                        v-on="on"
                                        v-on:click="setDuplicate(props.item)"
                                        class="button-margin-lr gridbutton">
                                        <v-icon small color="red">mdi-account-remove-outline</v-icon>
                                    </v-btn>
                                </template>
                                <span>Mark as duplicate</span>
                            </v-tooltip> 
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn 
                                        x-small 
                                        text icon 
                                        v-bind="attrs" 
                                        v-on="on"
                                        v-on:click="setToAssign(props.item)"
                                        class="button-margin-lr gridbutton">
                                        <v-icon small color="green">mdi-account-check-outline</v-icon>
                                    </v-btn>
                                </template>
                                <span>Mark as not a duplicate</span>
                            </v-tooltip> 
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn 
                                        x-small 
                                        text icon 
                                        v-bind="attrs" 
                                        v-on="on"
                                        v-on:click="assignPtenLead(props.item)"
                                        class="button-margin-lr gridbutton">
                                        <v-icon small>mdi-account-plus-outline</v-icon>
                                    </v-btn>
                                </template>
                                <span>Assign lead <br> (not a duplicate)</span>
                            </v-tooltip>  -->
                        </td>
                    </tr>
                </template>
            </v-data-table>
        </v-card>
        <cardFaqUpload ref="cardFaqUpload" title="accommodation faq"/>
        <showProgress ref="showProgress"/>
    </v-container>
</template>

<script>
    import btn_component from "@/components/ui/buttons/btn_component.vue";
    import longTextView from "@/components/ui/fields/longTextView.vue";
    import selector from "@/components/ui/selectors/selector.vue";
    import showProgress from "@/components/showProgress.vue";

    import cardWait from "@/components/syst/openai/cardWait.vue";
    import cardFaqUpload from "@/components/syst/openai/cardFaqUpload.vue";

    export default {
        components: {
            btn_component,
            longTextView,
            selector,
            showProgress,
            cardWait,
            cardFaqUpload,
        },
        props: {
        },
        data() {
            return {
                loading: true,
                firstTime: true,
                disableExport: false,

                faqTooltip: "Copy of accommodation faq's. Any changes need to be made there",
                
                languageCodes: [],
                languageCodesSelected: [],
                
                accommodationCodes: [],
                accommodationCodesSelected: [],

                files: [],
                
                search: "",

                headers: [
                    {text: 'Language', value: 'language', width: "50px", tdClass: 'align-text-top' },
                    {text: 'Accommodation', value: 'accommodation', width: "50px", tdClass: 'align-text-top'},
                    {text: 'Question', value: 'question', width: "250px", tdClass: 'align-text-top'},
                    {text: 'Answer', value: 'answer', width: "500px", tdClass: 'align-text-top' },
                    {text: 'Actions', value: '', width: "50px", tdClass: 'align-text-top'},
                ],
                faqs: [],
                filteredFaqs: [],
            }
        },
        mounted() {
            this.getFaqAccommodation();
        },
        methods: {
            getFaqAccommodation() {
                this.$axios.post("ares/json/ares/syst/openai/getFaqAccommodation.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "getFaqAccommodation"
                    },
                    getFaqAccommodation: {
                    },
                }).then(res => {
                    if (res.data.error) {
                        console.log(res.data.error);
                    } else {
                        this.faqs = res.data.getFaqAccommodation.items;
                        this.files = res.data.getFaqAccommodation.files;
                        this.languageCodes = res.data.getFaqAccommodation.languageKeuzes;
                        this.accommodationCodes = res.data.getFaqAccommodation.accommodationKeuzes;
                        if (this.firstTime) {
                            this.languageCodesSelected = res.data.getFaqAccommodation.languageKeuzes;
                            this.accommodationCodesSelected = res.data.getFaqAccommodation.accommodationKeuzes;
                            this.firstTime = false;
                        }
                        this.filterFaqs();
                        this.loading = false;
                    }
                });
            },
            inOptions(option, selectedOptions) {
                for (let i=0; i<selectedOptions.length; i++) {
                    if (option === selectedOptions[i].Option) {
                        return true;    
                    }
                }   
                return false;    
            },
            filterFaqs() {
                this.filteredFaqs = [];

                for (let i=0; i<this.faqs.length; i++) {
                    if (this.inOptions(this.faqs[i].language, this.languageCodesSelected) && this.inOptions(this.faqs[i].accommodation, this.accommodationCodesSelected)) {
                        this.filteredFaqs.push(this.faqs[i]);
                    }
                }
            },
            updateSelection(selectedField, codeField, newSelection) {
                //console.log(newSelection);
                this[selectedField] = newSelection;
                for (let i=0; i<this[codeField].length; i++) {
                    this[codeField][i].isSelected = false;
                    for (let j=0; j<this[selectedField].length; j++) {
                        if (this[codeField][i].Option === this[selectedField][j].Option) {
                            this[codeField][i].isSelected = true;
                        }
                    }
                }
            },
            updateData(data) {
                switch (data.field) {
                    case "languageCodesSelected":
                        this.updateSelection("languageCodesSelected", "languageCodes", data.value);
                        this.filterFaqs();
                        break;
                    case "accommodationCodesSelected":
                        this.updateSelection("accommodationCodesSelected", "accommodationCodes", data.value);
                        this.filterFaqs();
                        break;
                    default:
                        console.log("updateData - field not found: ", data);
                }
            },
            uploadFiles() {
                this.$refs.cardFaqUpload.openDialog(this.files);
            },
            actionClick(action) {
                switch (action) {
                    case "refresh":
                        this.getFaqAccommodation();
                        break;
                }
            },
            showInfo() {
            },
            buildReport() {
                this.disableExport = true;
                this.$refs.showProgress.open();
                this.$axios.post("ares/json/ares/syst/openai/excelExportFaqAccommodation.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "excelExportFaqAccommodation"
                    },
                    excelExportFaqAccommodation: {
                        items: this.filteredFaqs,
                    }
                }).then(res => {
                    if (res.data.error) {
                        console.log(res.data.error);
                    } else {
                        window.open(res.data.excelExportFaqAccommodation.filename, '_blank');
                    }
                    this.$refs.showProgress.close();
                    this.disableExport = false;
                });
            },
        }
    };
</script> 

<style scoped>
    .align-text-top {
        vertical-align: top;
    }
</style>
